export default function Footer() {
  return (
    <footer id="footer" className="bg-background-950 text-background-200">
      <div className="w-full px-4 md:px-6 py-14 md:py-16">
        <div className="max-w-6xl mx-auto">
          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-8 md:gap-10">
            <div>
              <h3 className="text-lg font-heading font-bold text-background-50 mb-4">布丁漫画</h3>
              <p className="text-sm text-background-400 leading-relaxed">
                布丁漫画下拉式阅读专区，提供流畅的下拉式漫画观看体验，免费看韩漫、国漫、日漫全集，支持在线追更，阅读不卡顿一气呵成。
              </p>
            </div>

            <div>
              <h3 className="text-sm font-semibold text-background-100 mb-4">快速导航</h3>
              <ul className="space-y-2.5">
                <li><a href="#topics" className="text-sm text-background-400 hover:text-primary-400 transition-colors cursor-pointer whitespace-nowrap">热门话题</a></li>
                <li><a href="#ranking" className="text-sm text-background-400 hover:text-primary-400 transition-colors cursor-pointer whitespace-nowrap">热门榜单</a></li>
                <li><a href="#index" className="text-sm text-background-400 hover:text-primary-400 transition-colors cursor-pointer whitespace-nowrap">专题索引</a></li>
                <li><a href="#faq" className="text-sm text-background-400 hover:text-primary-400 transition-colors cursor-pointer whitespace-nowrap">常见问答</a></li>
              </ul>
            </div>

            <div>
              <h3 className="text-sm font-semibold text-background-100 mb-4">漫画分类</h3>
              <ul className="space-y-2.5">
                <li><span className="text-sm text-background-400 whitespace-nowrap">韩漫热门</span></li>
                <li><span className="text-sm text-background-400 whitespace-nowrap">国漫精选</span></li>
                <li><span className="text-sm text-background-400 whitespace-nowrap">日漫经典</span></li>
                <li><span className="text-sm text-background-400 whitespace-nowrap">下拉式阅读</span></li>
              </ul>
            </div>

            <div>
              <h3 className="text-sm font-semibold text-background-100 mb-4">合作伙伴</h3>
              <p className="text-sm text-background-500">合作伙伴信息即将上线，敬请期待。</p>
            </div>
          </div>

          <div className="mt-10 pt-8 border-t border-background-800/50 flex flex-col sm:flex-row items-center justify-between gap-4">
            <p className="text-xs text-background-500">
              &copy; {new Date().getFullYear()} 布丁漫画. 本站内容仅供学习交流，版权归原作者所有。
            </p>
            <div className="flex items-center gap-4">
              <span className="text-xs text-background-500 cursor-pointer hover:text-primary-400 transition-colors whitespace-nowrap">用户协议</span>
              <span className="text-xs text-background-500 cursor-pointer hover:text-primary-400 transition-colors whitespace-nowrap">隐私政策</span>
              <span className="text-xs text-background-500 cursor-pointer hover:text-primary-400 transition-colors whitespace-nowrap">免责声明</span>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
}